import { z } from 'zod';
import { BroadcastChannel } from '../types/enums.js';
export const createSharedDocSchema = z.object({
    name: z.string().min(1),
    url: z.string().min(1),
    mimeType: z.string().min(1),
    message: z.string().nullable().optional(),
    recipientWorkerIds: z.array(z.string().uuid()).min(1),
    notifyChannels: z.array(z.nativeEnum(BroadcastChannel)).default(['wa']),
});
export const signDocSchema = z.object({
    signatureDataUrl: z.string().min(1),
});
//# sourceMappingURL=shared-doc.js.map